/**
 * Referenza Gallery Lightbox
 * Lightweight lightbox for referenza article gallery images.
 */
(function () {
  'use strict';

  const lightbox = document.getElementById('referenza-lightbox');
  if (!lightbox) return;

  const slides = lightbox.querySelectorAll('[data-slide]');
  const currentEl = lightbox.querySelector('[data-lightbox-current]');
  const totalSlides = slides.length;
  let currentIndex = 0;
  let isOpen = false;

  function open(index) {
    currentIndex = index;
    showSlide(currentIndex);
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
  }

  function close() {
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
  }

  function showSlide(index) {
    slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });
    if (slides[index]) {
      slides[index].classList.add('is-active');
    }
    if (currentEl) {
      currentEl.textContent = index + 1;
    }
  }

  function next() {
    currentIndex = (currentIndex + 1) % totalSlides;
    showSlide(currentIndex);
  }

  function prev() {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    showSlide(currentIndex);
  }

  /* Event: open triggers */
  document.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = parseInt(this.getAttribute('data-lightbox-index'), 10) || 0;
      open(index);
    });
  });

  /* Event: close */
  lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  /* Event: overlay click */
  lightbox.querySelector('.referenza-lightbox__overlay').addEventListener('click', close);

  /* Event: prev/next */
  lightbox.querySelectorAll('[data-lightbox-prev]').forEach(function (btn) {
    btn.addEventListener('click', prev);
  });
  lightbox.querySelectorAll('[data-lightbox-next]').forEach(function (btn) {
    btn.addEventListener('click', next);
  });

  /* Keyboard navigation */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });

  /* Swipe support for touch devices */
  var touchStartX = 0;
  var touchEndX = 0;

  lightbox.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  lightbox.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
  }, { passive: true });
})();
